import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import AuthLayout from "@/components/AuthLayout";
import { api, extractError } from "@/lib/api";
import { useI18n } from "@/contexts/LanguageContext";

import { useAuth } from "@/contexts/AuthContext";

export default function ResetPassword() {
  const { t } = useI18n();
  const { setUser } = useAuth();
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) {
      setError(t("auth.errors.minPassword"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setUser(null);
      setSuccess(true);
    } catch (err) {
      setError(extractError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title={t("auth.reset.title")} subtitle={t("auth.reset.subtitle")} testId="reset-page">
      {success ? (
        <div className="space-y-6" data-testid="reset-success">
          <div className="nvl-card p-5 text-sm">{t("auth.reset.success")}</div>
          <Link to="/login" className="nvl-btn nvl-btn-primary" data-testid="reset-login-link">
            {t("common.signIn")}
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="reset-form">
          <div>
            <label htmlFor="reset-password-input" className="text-xs uppercase tracking-widest" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
              {t("common.password")}
            </label>
            <input id="reset-password-input"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              className="nvl-input mt-2"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="reset-password-input"
            />
          </div>
          {error ? (
            <div className="text-sm" style={{ color: "hsl(var(--destructive))" }} data-testid="reset-error">
              {error}
            </div>
          ) : null}
          <button
            type="submit"
            disabled={loading}
            className="nvl-btn nvl-btn-primary w-full disabled:opacity-60"
            data-testid="reset-submit-button"
          >
            {loading ? t("common.loading") : t("auth.reset.submit")}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
